import {getNodeId} from "../../../Utility";
import {getStowAssociateScanMetrics} from "../../../resources/StowResource";

export function fetchAssociateScanMetrics(dispatcher) {
    const request = {
        filters: {
            NODE: [getNodeId()]
        },
        metrics: ["SCAN_TIME"],
        groupBy: "ASSOCIATE"
    }
    getAssociateScanMetrics(dispatcher, request)
}

async function getAssociateScanMetrics(dispatcher, request) {
    try {
        const result = await getStowAssociateScanMetrics(request);
        dispatcher({ type: "RECEIVE_DATA", data: result });
    } catch (error) {
        console.error("Error fetching associate scan metrics:", error);
    }
}


// WEBPACK FOOTER //
// ./src/components/associate/network/AssociateNetworkAPI.js